import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-l-home",
  "use": "icon-l-home-usage",
  "viewBox": "0 0 165 165",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 165 165\" id=\"icon-l-home\"><path d=\"M119.333 125.459H46v-52.69l36.666-33.076 15.843 14.291V42.596h7.758v18.387l13.066 11.786zm-11.066-65.366V40.596H96.509v8.89L82.666 37 44 71.879v55.58h77.333v-55.58z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol